import React, { useEffect, useState } from "react";

import { TextField } from "@mui/material";
import { httpNonToken, endPoints } from "../../globalConf/http-non-token";
import Loading from "../loading/loading";

import CustomToastify, { toastMes } from "../../globalConf/notification";

const AnatomyParts = ({ anatomies, setFlag, flag }) => {
  const [success, setSuccess] = useState(false);
  const [edit, setEdit] = useState(false);
  const [add, setAdd] = useState(false);
  const [anatomiesArr, setAnatomiesArr] = useState([]);
  const [selectedPart, setSelectedPart] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    (async () => {
      let anatomiesArray = [...anatomiesArr];
      for (let i = 0; i < anatomies.length; i++) {
        anatomiesArray.push(anatomies[i].name);
      }

      setAnatomiesArr(anatomiesArray);
    })();
  }, [flag]);

  const handleEdit = async (id, val) => {
    try {
      await httpNonToken.put(`${endPoints.updateAnatomy}/${id}`, {
        name: val,
      });
      setFlag(!flag);

      toastMes.success("Anatomy Updated Successfully");
      setSelectedPart("");
      setEdit(false);
    } catch ({ response }) {
      toastMes.error(response.data.message);
    }
  };

  const handleAdd = async () => {
    try {
      await httpNonToken.post(`${endPoints.createAnatomy}`, {
        name: selectedPart,
      });
      setFlag(!flag);

      toastMes.success("Anatomy Created Successfully");
      setSelectedPart("");
      setAdd(false);
    } catch ({ response }) {
      toastMes.error(response.data.message);
    }
  };

  const handleAnatomyChange = (e, position = 0) => {
    const updatedAnatomyName = anatomiesArr.map((item, index) => {
      return index === position ? e.target.value : item;
    });
    setAnatomiesArr(updatedAnatomyName);
    // setSelectedPart(e.target.value);
  };

  return (
    <div className="w-100 overflow-auto px-3 mt-5 bg-white">
      <div className="row border">
        <div className="col-11  text-bold py-4">Anatomy Parts</div>
        {add ? (
          <div className="row">
            <div className="col-10">
              <TextField
                fullWidth
                className="mb-3"
                type="text"
                id="outlined-basic"
                label="Add Part Name"
                size="small"
                value={selectedPart}
                onChange={(e) => setSelectedPart(e.target.value)}
              />
            </div>
            <div className="col-2 mt-2">
              <i
                className="fa-solid fa-circle-xmark text-danger cursor-pointer mx-2 fa-lg"
                onClick={() => {
                  setAdd(false);
                  setSelectedPart("");
                }}
              ></i>
              <i
                className="fa-solid fa-circle-check text-success cursor-pointer mx-2 fa-lg"
                onClick={handleAdd}
              ></i>
            </div>
          </div>
        ) : (
          <p className="col-1 text-bold mt-4">
            <i
              className="fa-solid fa-circle-plus fa-lg text-primary cursor-pointer"
              onClick={() => {
                setAdd(true);
                setEdit(false);
              }}
            ></i>
          </p>
        )}
      </div>
      <div className="row">
        {anatomies.length > 0
          ? anatomies.map((anatomy, idx) => {
              return edit && selectedPart === anatomy.name ? (
                <div key={idx} className="col-3 border-none p-4">
                  <TextField
                    type="text"
                    id="outlined-basic"
                    label="Edit Part Name"
                    size="small"
                    value={anatomiesArr[idx]}
                    onChange={(e) => handleAnatomyChange(e, idx)}
                  />
                  <div className="text-center mt-1">
                    <i
                      className="fa-solid fa-circle-xmark text-danger cursor-pointer mx-2 fa-lg"
                      onClick={() => {
                        setEdit(false);
                        setSelectedPart("");
                      }}
                    ></i>
                    <i
                      className="fa-solid fa-circle-check text-success cursor-pointer mx-2 fa-lg"
                      onClick={() => handleEdit(anatomy.id, anatomiesArr[idx])}
                    ></i>
                  </div>
                </div>
              ) : (
                <p
                  key={idx}
                  onClick={() => {
                    setEdit(true);
                    setAdd(false);
                    setSelectedPart(anatomy.name);
                  }}
                  className="border p-4 mb-0 col-3 text-center"
                >
                  {anatomy.name}
                </p>
              );
            })
          : null}
      </div>

      {/* <CustomToastify  duration={false} /> */}
    </div>
  );
};

export default AnatomyParts;
